import { StatusChipV2 } from '@cast/design-system';

import {
  isCostOptimizedWorkload,
  isPerformanceOptimizedWorkload,
} from 'features/cluster/workload-optimization/impact/_utils';
import { PreparedWorkload } from 'features/workload-optimization';

export const WorkloadOptimizedCell = (workload: PreparedWorkload) => {
  if (isCostOptimizedWorkload(workload)) {
    return (
      <span data-testid="optimized" data-sort={-1}>
        <StatusChipV2
          size="small"
          variant="strong"
          color="success"
          label="COST"
        />
      </span>
    );
  }

  if (isPerformanceOptimizedWorkload(workload)) {
    return (
      <span data-testid="optimized" data-sort={1}>
        <StatusChipV2
          size="small"
          variant="strong"
          color="neutral"
          label="PERFORMANCE"
        />
      </span>
    );
  }

  return <span data-testid="optimized" data-sort={0} />;
};
